import { YXSign } from '@panda/cache/src/shared/define/Share';

export interface UploadConfig {
  trunkSize?: number;
  urlDns?: string;
  fileExts?: string[];
}

export interface AllConfig {
  yxSign?: YXSign;
  trunkSize: number;
  urlDns: string;
  fileExts: string[];
}

export interface ErrorObj {
  errCode: number;
  errMsg: string;
}

export enum UploadStatus {
  ToUpload = 0,
  Uploading,
  Uploaded
}

export interface FileObj {
  fileKey: string;
  file: File;
  fileName: string;
  fileSizeMb: string;
  format?: string;
  status: UploadStatus;
  checked: boolean;
  progress: string;
  contentId: number;
  objectName?: string;
  bucketName?: string;
  xhr?: XMLHttpRequest | null;
}

export interface NosInfo {
  bucketName: string;
  objectName: string;
  nosToken: string;
}

export enum UploadEvent {
  Error = 'error',
  AllUploaded = 'allUploader',
  Uploaded = 'uploaded',
  Progress = 'progress',
  MisMatch = 'misMatch',
  Empty = 'empty',
  Remove = 'remove',
}

export enum ErrorShowType {
  Console = 1,
  Notify,
  Modal
}
export interface TrunkRequest {
  serveIp: string;
  bucketName: string;
  objectName: string;
  nosToken: string;
}
export interface OffsetRequest extends TrunkRequest{
  fileKey: string;
}

export interface FileTrunkObj {
  file: File;
  fileKey: string;
  fileIndex: number;
  offset: number;
  trunkSize: number;
  trunkEnd: number;
  context?: string;
}
